import { SPACING } from '@zola/zola-ui/src/styles/emotion';

import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  gap: ${SPACING.SM};
  justify-content: center;
`;
